import { ReactElement } from 'react';
import { isMobile } from 'utils/is-mobile';
import './styles.less';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const ListViewSkeleton = ({
  limit = 0
}: {
  limit?: number;
}): ReactElement => {
  return (
    <>
      {[...Array(limit).keys()].map(key => (
        <Skeleton
          key={key}
          loading={true}
          title={{
            className: isMobile()
              ? 'list-view-mobile-skeleton'
              : 'list-view-skeleton'
          }}
          paragraph={false}
          active
        />
      ))}
    </>
  );
};
